import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from "../../../../services/task.service";

@Component({
  selector: 'app-common-status-notify',
  templateUrl: './common-status-notify.component.html',
  styleUrls: ['../parts.css']
})
export class CommonStatusNotifyComponent implements OnInit {

  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据

  // 分组
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组'; // 条件二默认文字

  statusColumnDisplayText = '状态'; // 状态列显示文字
  statusPopVisible = false; // 状态列pop显示
  statusColumnList = []; // 状态列可选值

  columnValueDisplayText = '某个值'; // 状态列的值的默认文字
  columnValuePopVisible = false; // 状态列值pop显示
  columnValueList = []; // 状态列值可选择值

  mailPopVisible = false;
  receiverPopVisible = false;
  smsPattern = 'custom';
  smsTemplateList;
  notificationData: any; // 存放通知组件数据

  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  backFillData: any; // 回填数据
  categorieId: string; // 存放当前目录ID

  automation = {
    boardId: '',
    columnId: '',
    categoryId: '',
    relationId: '',
    groupId: '',
    email: null,
    siteMessage: null,
    sms: null,
    columnValue: {
      index: null
    },
    receiver: {
    },
    instanceDescription: ''
  }; // 存放入参数据
  @ViewChild('pulseIntegration') pulseIntegration: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService
  ) { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      if (this.boardColumnData && this.boardColumnData.length > 0) {
        for (const column of this.boardColumnData) {
          if (column.type === 'status') {
            this.statusColumnList.push(column);
          } else if (column.type === 'taskProgress') {
            this.statusColumnList.push(column);
          }
        }
      }
    }
    // 初始化自动化数据
    if (this.instanceData && this.instanceData.config) {
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      if (this.automation.groupId) {
        this.groupConditionId = this.automation.groupId;
        const groupNames = [];
        for (const group of this.boardGroupData) {
          if (this.groupConditionId.includes(group.id)) {
            group.checked = true;
            groupNames.push(group.title);
          }
        }
        this.groupConditionDisplayText = groupNames.join(',');
        this.groupConditionDisplayText = this.groupConditionDisplayText.length > 12 ?
          `${this.groupConditionDisplayText.slice(0,12)}...` : this.groupConditionDisplayText;
      }
      if (this.automation.columnId && this.statusColumnList.length > 0) {
        for (const statusColumn of this.statusColumnList) {
          if (statusColumn.id === this.automation.columnId) {
            this.statusColumnDisplayText = statusColumn.title;
            this.columnValueList = statusColumn.labels;
            for (let label of this.columnValueList) {
              if (label.index === this.automation.columnValue.index) {
                this.columnValueDisplayText = label.label;
                break;
              }
            }
            break;
          }
        }
      }
      this.notificationData = this.instanceData.config.email || this.instanceData.config.siteMessage || this.instanceData.config.sms;
    }
    if (this.smsPattern === 'template') {
      this.taskService.querySmsTemplateList().subscribe(res => {
        this.smsTemplateList = res;
        if (this.smsTemplateList && this.smsTemplateList.length > 0) {
          for (const template of this.smsTemplateList) {
            template['content'] = JSON.parse(template['content']);
          }
        }
      });
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.packageData();
  }

  // 分组变更
  groupConditionChange(item) {
    item.checked = !item.checked;
    this.getGroupIds();
    this.automation.groupId = this.groupConditionId;
    this.packageData();
  }

  getGroupIds() {
    const idSet = new Set();
    const groupNames = [];
    for (const group of this.boardGroupData) {
      if (group.checked) {
        idSet.add(group.id);
        groupNames.push(group.title);
      }
    }
    const ids = Array.from(idSet);
    this.groupConditionId = ids.join(',');
    this.groupConditionDisplayText = groupNames.join(',');
    this.groupConditionDisplayText = this.groupConditionDisplayText.length > 12 ?
      `${this.groupConditionDisplayText.slice(0,12)}...` : this.groupConditionDisplayText;
  }

  statusSelectChange(item) {
    this.statusColumnDisplayText = item.title;
    this.automation.columnId = item.id;
    this.statusPopVisible = false;
    this.columnValueList = item.labels;
    this.automation.columnValue.index = null;
    this.columnValueDisplayText = '某个值';
    this.packageData();
  }

  columnValueSelectChange(item) {
    this.columnValueDisplayText = item.label;
    this.automation.columnValue.index = item.index;
    this.columnValuePopVisible = false;
    this.packageData();
  }

  getNotificationData(data) {
    this.notificationData = data.content;
    if (data.type === 'email') {
      this.automation.email = data.content;
      this.automation.siteMessage = null;
      this.automation.sms = null;
    } else if (data.type === 'siteMessage') {
      this.automation.siteMessage = data.content;
      this.automation.email = null;
      this.automation.sms = null;
    } else {
      this.automation.sms = data.content;
      this.automation.email = null;
      this.automation.siteMessage = null;
    }
    this.mailPopVisible = false;
    this.packageData();
  }

  getUserData(data) {
    this.automation.receiver = data;
    this.packageData();
  }

  packageData() {
    this.automation.instanceDescription = '在 ' + this.groupConditionDisplayText + ' 中，' + '当 ' + this.statusColumnDisplayText
      + ' 变更为 ' + this.columnValueDisplayText + ' 时，' +  '发 通知 给 客户';
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus() : boolean {
    return this.automation.groupId &&
      this.automation.columnId &&
      this.automation.columnValue.index !== null &&
      (this.automation.receiver && this.automation.receiver['value'] && this.automation.receiver['value'].length > 0) &&
      (this.automation.email || this.automation.siteMessage || this.automation.sms);
  }
}
